var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.96387H16C15.59 7.96387 15.25 7.62387 15.25 7.21387C15.25 6.80387 15.59 6.46387 16 6.46387H22C22.41 6.46387 22.75 6.80387 22.75 7.21387C22.75 7.62387 22.41 7.96387 22 7.96387Z",
    fill: "#3776B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.96387H2C1.59 7.96387 1.25 7.62387 1.25 7.21387C1.25 6.80387 1.59 6.46387 2 6.46387H6C6.41 6.46387 6.75 6.80387 6.75 7.21387C6.75 7.62387 6.41 7.96387 6 7.96387Z",
    fill: "#3776B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4639C7.66 11.4639 5.75 9.55387 5.75 7.21387C5.75 4.87387 7.66 2.96387 10 2.96387C12.34 2.96387 14.25 4.87387 14.25 7.21387C14.25 9.55387 12.34 11.4639 10 11.4639ZM10 4.46387C8.48 4.46387 7.25 5.69387 7.25 7.21387C7.25 8.73387 8.48 9.96387 10 9.96387C11.52 9.96387 12.75 8.73387 12.75 7.21387C12.75 5.69387 11.52 4.46387 10 4.46387Z",
    fill: "#3776B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.9639H18C17.59 18.9639 17.25 18.6239 17.25 18.2139C17.25 17.8039 17.59 17.4639 18 17.4639H22C22.41 17.4639 22.75 17.8039 22.75 18.2139C22.75 18.6239 22.41 18.9639 22 18.9639Z",
    fill: "#3776B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.9639H2C1.59 18.9639 1.25 18.6239 1.25 18.2139C1.25 17.8039 1.59 17.4639 2 17.4639H8C8.41 17.4639 8.75 17.8039 8.75 18.2139C8.75 18.6239 8.41 18.9639 8 18.9639Z",
    fill: "#3776B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.4639C11.66 22.4639 9.75 20.5539 9.75 18.2139C9.75 15.8739 11.66 13.9639 14 13.9639C16.34 13.9639 18.25 15.8739 18.25 18.2139C18.25 20.5539 16.34 22.4639 14 22.4639ZM14 15.4639C12.48 15.4639 11.25 16.6939 11.25 18.2139C11.25 19.7339 12.48 20.9639 14 20.9639C15.52 20.9639 16.75 19.7339 16.75 18.2139C16.75 16.6939 15.52 15.4639 14 15.4639Z",
    fill: "#3776B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.f85b440f39ea78fc2aab619eae11315b.svg";
export { ForwardRef as ReactComponent };